module.exports = __webpack_public_path__ + "static/media/Filter_Major_Cabin_xparent.5094ae6a.png";